exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "badge{pointer-events:none;padding:0 6px;min-width:30px;height:30px;line-height:1em;display:inline-flex;justify-content:center;align-items:center;border-radius:17px;background-color:#ff3a4c}badge>label{margin:0;font-weight:400;line-height:1em;transform:translateY(0.6px)}", ""]);

